export const ZONES = {
  gier: {
    nom: 'Vallée du Gier',
    texte: "au cœur de la vallée du Gier, à quelques minutes de notre atelier de Saint-Chamond",
  },
  metropole: {
    nom: 'Saint-Étienne Métropole',
    texte: "dans l'agglomération de Saint-Étienne Métropole, facilement accessible depuis Saint-Chamond par l'A47 ou la ligne TER",
  },
  ondaine: {
    nom: "Vallée de l'Ondaine",
    texte: "dans la vallée de l'Ondaine, à l'ouest de Saint-Étienne",
  },
  pilat: {
    nom: 'Parc du Pilat',
    texte: "sur les hauteurs du Parc naturel régional du Pilat",
  },
  forez: {
    nom: 'Plaine du Forez',
    texte: "dans la plaine du Forez, entre Saint-Étienne et Montbrison",
  },
  roannais: {
    nom: 'Roannais',
    texte: "dans le Roannais, au nord du département de la Loire",
  },
};

// [slug, nom, code postal, km depuis Saint-Chamond, zone, habitants, url d'une page dédiée existante]
const DONNEES = [
  ['saint-chamond', 'Saint-Chamond', '42400', 0, 'gier', '35 000', '/reparation-iphone-saint-chamond'],
  ['lhorme', "L'Horme", '42152', 3, 'gier', '5 000', '/reparation-iphone-lhorme'],
  ['cellieu', 'Cellieu', '42320', 4, 'gier', '1 900'],
  ['la-grand-croix', 'La Grand-Croix', '42320', 5, 'gier', '5 200', '/reparation-iphone-la-grand-croix'],
  ['lorette', 'Lorette', '42420', 6, 'gier', '4 800'],
  ['saint-paul-en-jarez', 'Saint-Paul-en-Jarez', '42740', 6, 'gier', '4 600'],
  ['farnay', 'Farnay', '42320', 6, 'gier', '1 400'],
  ['la-terrasse-sur-dorlay', 'La Terrasse-sur-Dorlay', '42740', 7, 'gier', '800'],
  ['chagnon', 'Chagnon', '42800', 8, 'gier', '500'],
  ['la-valla-en-gier', 'La Valla-en-Gier', '42131', 8, 'pilat', '1 000'],
  ['rive-de-gier', 'Rive-de-Gier', '42800', 9, 'gier', '15 000', '/reparation-iphone-rive-de-gier'],
  ['genilac', 'Génilac', '42800', 9, 'gier', '3 700'],
  ['valfleury', 'Valfleury', '42320', 9, 'gier', '700'],
  ['saint-jean-bonnefonds', 'Saint-Jean-Bonnefonds', '42650', 9, 'metropole', '7 000'],
  ['sorbiers', 'Sorbiers', '42290', 10, 'metropole', '8 000', '/reparation-iphone-sorbiers'],
  ['doizieux', 'Doizieux', '42740', 10, 'pilat', '800'],
  ['saint-martin-la-plaine', 'Saint-Martin-la-Plaine', '42800', 11, 'gier', '4 000'],
  ['chateauneuf', 'Châteauneuf', '42800', 11, 'gier', '1 500'],
  ['saint-etienne', 'Saint-Étienne', '42000', 12, 'metropole', '175 000', '/reparation-telephone-saint-etienne'],
  ['la-talaudiere', 'La Talaudière', '42350', 12, 'metropole', '6 500'],
  ['saint-joseph', 'Saint-Joseph', '42800', 12, 'gier', '2 000'],
  ['saint-christo-en-jarez', 'Saint-Christo-en-Jarez', '42320', 12, 'gier', '1 900'],
  ['tartaras', 'Tartaras', '42800', 13, 'gier', '800'],
  ['saint-romain-en-jarez', 'Saint-Romain-en-Jarez', '42800', 13, 'gier', '1 100'],
  ['fontanes', 'Fontanès', '42140', 13, 'gier', '600'],
  ['dargoire', 'Dargoire', '42800', 14, 'gier', '400'],
  ['sainte-croix-en-jarez', 'Sainte-Croix-en-Jarez', '42800', 14, 'pilat', '500'],
  ['pavezin', 'Pavezin', '42410', 15, 'pilat', '400'],
  ['marcenod', 'Marcenod', '42140', 15, 'gier', '700'],
  ['saint-heand', 'Saint-Héand', '42570', 16, 'metropole', '3 700'],
  ['saint-priest-en-jarez', 'Saint-Priest-en-Jarez', '42270', 16, 'metropole', '6 200'],
  ['villars', 'Villars', '42390', 17, 'metropole', '8 500'],
  ['saint-genest-lerpt', 'Saint-Genest-Lerpt', '42530', 18, 'metropole', '6 200'],
  ['la-ricamarie', 'La Ricamarie', '42150', 18, 'ondaine', '7 500'],
  ['planfoy', 'Planfoy', '42660', 18, 'pilat', '1 100'],
  ['le-bessat', 'Le Bessat', '42660', 18, 'pilat', '500'],
  ['roche-la-moliere', 'Roche-la-Molière', '42230', 19, 'metropole', '10 000'],
  ['le-chambon-feugerolles', 'Le Chambon-Feugerolles', '42500', 20, 'ondaine', '12 500'],
  ['saint-bonnet-les-oules', 'Saint-Bonnet-les-Oules', '42330', 22, 'forez', '1 800'],
  ['firminy', 'Firminy', '42700', 22, 'ondaine', '17 000', '/reparation-iphone-firminy'],
  ['la-fouillouse', 'La Fouillouse', '42480', 22, 'metropole', '4 600'],
  ['pelussin', 'Pélussin', '42410', 22, 'pilat', '3 700'],
  ['saint-genest-malifaux', 'Saint-Genest-Malifaux', '42660', 22, 'pilat', '3 100'],
  ['unieux', 'Unieux', '42240', 25, 'ondaine', '8 700'],
  ['fraisses', 'Fraisses', '42490', 25, 'ondaine', '3 900'],
  ['andrezieux-boutheon', 'Andrézieux-Bouthéon', '42160', 26, 'forez', '10 000', '/reparation-iphone-andrezieux'],
  ['saint-galmier', 'Saint-Galmier', '42330', 27, 'forez', '6 000'],
  ['veauche', 'Veauche', '42340', 28, 'forez', '9 000'],
  ['maclas', 'Maclas', '42520', 28, 'pilat', '1 900'],
  ['saint-paul-en-cornillon', 'Saint-Paul-en-Cornillon', '42240', 28, 'ondaine', '1 700'],
  ['saint-just-saint-rambert', 'Saint-Just-Saint-Rambert', '42170', 30, 'forez', '15 000'],
  ['bonson', 'Bonson', '42160', 30, 'forez', '4 000'],
  ['chazelles-sur-lyon', 'Chazelles-sur-Lyon', '42140', 30, 'forez', '5 500'],
  ['chavanay', 'Chavanay', '42410', 30, 'pilat', '3 000'],
  ['sury-le-comtal', 'Sury-le-Comtal', '42450', 32, 'forez', '6 000'],
  ['saint-julien-molin-molette', 'Saint-Julien-Molin-Molette', '42220', 32, 'pilat', '1 200'],
  ['saint-pierre-de-boeuf', 'Saint-Pierre-de-Bœuf', '42520', 32, 'pilat', '1 800'],
  ['saint-marcellin-en-forez', 'Saint-Marcellin-en-Forez', '42680', 34, 'forez', '4 600'],
  ['bourg-argental', 'Bourg-Argental', '42220', 35, 'pilat', '3 000'],
  ['montrond-les-bains', 'Montrond-les-Bains', '42210', 35, 'forez', '5 200'],
  ['saint-romain-le-puy', 'Saint-Romain-le-Puy', '42610', 40, 'forez', '4 000'],
  ['montbrison', 'Montbrison', '42600', 45, 'forez', '16 000'],
  ['panissieres', 'Panissières', '42360', 45, 'forez', '3 000'],
  ['savigneux', 'Savigneux', '42600', 46, 'forez', '3 500'],
  ['feurs', 'Feurs', '42110', 48, 'forez', '8 000'],
  ['balbigny', 'Balbigny', '42510', 55, 'forez', '3 000'],
  ['boen-sur-lignon', 'Boën-sur-Lignon', '42130', 60, 'forez', '3 000'],
  ['saint-just-en-chevalet', 'Saint-Just-en-Chevalet', '42430', 85, 'roannais', '1 200'],
  ['villerest', 'Villerest', '42300', 88, 'roannais', '4 800'],
  ['commelle-vernay', 'Commelle-Vernay', '42120', 88, 'roannais', '3 000'],
  ['le-coteau', 'Le Coteau', '42120', 89, 'roannais', '7 000'],
  ['roanne', 'Roanne', '42300', 90, 'roannais', '35 000'],
  ['riorges', 'Riorges', '42153', 92, 'roannais', '11 000'],
  ['perreux', 'Perreux', '42120', 92, 'roannais', '2 300'],
  ['mably', 'Mably', '42300', 93, 'roannais', '8 000'],
  ['renaison', 'Renaison', '42370', 98, 'roannais', '3 000'],
  ['charlieu', 'Charlieu', '42190', 105, 'roannais', '3 500'],
];

export const VILLES = DONNEES.map(([slug, nom, cp, km, zone, hab, url]) => ({ slug, nom, cp, km, zone, hab, ...(url ? { url } : {}) }));

export const villeUrl = (ville) => ville.url || `/reparation-telephone/${ville.slug}`;

export const getVille = (slug) => VILLES.find((x) => x.slug === slug);

export const villesProches = (ville, n = 8) =>
  VILLES.filter((x) => x.slug !== ville.slug)
    .sort((a, b) => Math.abs(a.km - ville.km) - Math.abs(b.km - ville.km))
    .slice(0, n);
